var w = Object.defineProperty;
var l = (i, t, e) => t in i ? w(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var u = (i, t, e) => l(i, typeof t != "symbol" ? t + "" : t, e);
const c = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, h = {
  PROD: "https://api.credenza3.com",
  STAGING: "https://api.staging.credenza3.com",
  LOCAL: "http://localhost:8082"
}, f = {
  PROD: "https://accounts.credenza3.com",
  STAGING: "https://accounts.staging.credenza3.com",
  LOCAL: "http://localhost:8081"
};
function d(i) {
  switch (i.env) {
    case c.LOCAL:
      return f.LOCAL;
    case c.STAGING:
      return f.STAGING;
    case c.PROD:
      return f.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
function r(i) {
  switch (i.env) {
    case c.LOCAL:
      return h.LOCAL;
    case c.STAGING:
      return h.STAGING;
    case c.PROD:
      return h.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
class k {
  constructor() {
    u(this, "name", "account");
    u(this, "sdk");
  }
  async _initialize(t) {
    this.sdk = t;
  }
  async _updateAccountContact(t) {
    const e = `${d(this.sdk)}/accounts/me/change-contact`, n = await fetch(e, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({
        ..."email" in t ? { email: t.email.trim() } : {},
        ..."phone" in t ? { phone: t.phone.trim() } : {},
        ..."code" in t ? { code: t.code.trim() } : {}
      })
    });
    if (!n.ok) throw new Error(`Request failed: ${n.statusText}`);
    return await n.json();
  }
  async changeEmail(t) {
    return await this._updateAccountContact({ email: t });
  }
  async changePhone(t) {
    return await this._updateAccountContact({ phone: t });
  }
  async verifyCode(t) {
    return await this._updateAccountContact({ code: t });
  }
  async pendingVerificationContacts() {
    const t = `${d(this.sdk)}/accounts/me/change-contact`, e = await fetch(t, {
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!e.ok) throw new Error(`Request failed: ${e.statusText}`);
    return await e.json();
  }
  async info() {
    const t = `${d(this.sdk)}/oauth2/userinfo`, e = await fetch(t, {
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!e.ok) throw new Error(`Cannot get userInfo: ${e.statusText}`);
    return await e.json();
  }
  async updateProfile(t) {
    if (!t.name && !t.picture) throw new Error("Nothing to update");
    const e = `${d(this.sdk)}/accounts/me`, n = await fetch(e, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({
        ...t.name ? { name: t.name.trim() } : {},
        ...t.picture ? { image: t.picture.trim() } : {}
      })
    });
    if (!n.ok) throw new Error(`Cannot update user: ${n.statusText}`);
    return await n.json();
  }
  async changePassword(t) {
    if (!t.oldPassword || !t.newPassword) throw new Error("Invalid parameters");
    if (t.newPassword !== t.confirmPassword) throw new Error("Passwords do not match");
    const e = `${d(this.sdk)}/accounts/me/password`, n = await fetch(e, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({
        old_password: t.oldPassword.trim(),
        new_password: t.newPassword.trim(),
        confirm_password: t.confirmPassword.trim()
      })
    });
    if (!n.ok) throw new Error(`Cannot change password: ${n.statusText}`);
    return await n.json();
  }
  async getFriendsPaginated(t) {
    const e = new URLSearchParams();
    t != null && t.status && e.append("status", t.status), t != null && t.client_id && e.append("client_id", t.client_id), t != null && t.include_requester_data && e.append("include_requester_data", t.include_requester_data.toString()), t != null && t.include_friend_data && e.append("include_friend_data", t.include_friend_data.toString()), t != null && t.include_sui_data && e.append("include_sui_data", t.include_sui_data.toString()), t != null && t.include_evm_data && e.append("include_evm_data", t.include_evm_data.toString()), t != null && t.limit && e.append("limit", t.limit.toString()), t != null && t.offset && e.append("offset", t.offset);
    const n = `${r(this.sdk)}/friends?${e.toString()}`, s = await fetch(n, {
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!s.ok) throw new Error(`Cannot get friends: ${s.statusText}`);
    return await s.json();
  }
  async sendFriendRequest(t, e) {
    const n = e ? `?client_id=${e}` : "", s = `${r(this.sdk)}/friends/request${n}`, o = await fetch(s, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({ sub: t })
    });
    if (!o.ok) throw new Error(`Cannot send friend request: ${o.statusText}`);
    return await o.json();
  }
  async acceptFriendRequest(t) {
    const e = `${r(this.sdk)}/friends/${t}/accept`, n = await fetch(e, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!n.ok) throw new Error(`Cannot accept friend request: ${n.statusText}`);
    return await n.json();
  }
  async blockUser(t, e) {
    const n = e ? `?client_id=${e}` : "", s = `${r(this.sdk)}/friends/block${n}`, o = await fetch(s, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({ sub: t })
    });
    if (!o.ok) throw new Error(`Cannot block user: ${o.statusText}`);
    return await o.json();
  }
  async unblockUser(t, e) {
    const n = e ? `?client_id=${e}` : "", s = `${r(this.sdk)}/friends/unblock${n}`, o = await fetch(s, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({ sub: t })
    });
    if (!o.ok) throw new Error(`Cannot unblock user: ${o.statusText}`);
    return await o.json();
  }
  async removeFriend(t, e) {
    const n = e ? `?client_id=${e}` : "", s = `${r(this.sdk)}/friends/sub/${t}${n}`, o = await fetch(s, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!o.ok) throw new Error(`Cannot remove friend: ${o.statusText}`);
    return await o.json();
  }
  async getFriendInfo(t, e) {
    const n = new URLSearchParams();
    e != null && e.client_id && n.append("client_id", e.client_id), (e == null ? void 0 : e.include_sui_data) !== void 0 && n.append("include_sui_data", e.include_sui_data.toString()), (e == null ? void 0 : e.include_evm_data) !== void 0 && n.append("include_evm_data", e.include_evm_data.toString());
    const s = `${r(this.sdk)}/friends/info/${t}${n.toString() ? "?" + n.toString() : ""}`, o = await fetch(s, {
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!o.ok) throw new Error(`Cannot get friend info: ${o.statusText}`);
    return await o.json();
  }
}
export {
  k as AccountExtension
};
